import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import Icon from 'Components/Atoms/Icon/Icon';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';
import SnackbarActionText from './SnackbarActionText';
import SnackbarTitle from './SnackbarTitle';
import SnackbarAction from './SnackbarAction';

export default function SnackbarUploadError({ id, message }) {
    const { t } = useTranslation('common');

    return (
        <SnackbarCard variant="error">
            <SnackbarLayout>
                <div className="shrink-0">
                    <Icon name="exclamation-triangle" className="text-danger" color="currentColor" size={24} />
                </div>
                <SnackbarContent>
                    <SnackbarActionText>{t('upload-error')}</SnackbarActionText>
                    <SnackbarTitle>{message}</SnackbarTitle>
                </SnackbarContent>
                <SnackbarAction>
                    <Button size="small" variant="primary" onClick={() => toast.dismiss(id)}>
                        {t('accept')}
                    </Button>
                </SnackbarAction>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarUploadError.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    message: PropTypes.string.isRequired,
};
